import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import AppActions from '../../app/app_actions';
import * as agui from 'arm-gui/dist/controls';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, UiUtils, NumberFormatter, DateFormatter, i18n, isAuth } from 'arm-common';
import { isNullOrUndefined } from 'util';
import ProdottoActions from './prodotto_actions'
import { resolve } from 'path';
import SwitchButton from '../shared/switchButtonV4.jsx'
import LineaDocumentUpload from './LineaDocumentUpload.jsx'
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx'
import { fileURLToPath } from 'url';

class PacchettoCard extends React.Component {

    constructor(props) {
        super(props);
        this.componentName = '[LineaCard.jsx] ';
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.onClickSalvaLinea = this.onClickSalvaLinea.bind(this);
        this.inputChangeHandlerLinea = this.inputChangeHandlerLinea.bind(this);
        this.showConfirmPanelLinea = this.showConfirmPanelLinea.bind(this);
        this.annullaCreazioneLinea = this.annullaCreazioneLinea.bind(this);
        this.validateFormLinea = this.validateFormLinea.bind(this);
        this.salvaPacchettoLinea = this.salvaPacchettoLinea.bind(this);
        this.columnDelete = this.columnDelete.bind(this);
        this.inizializzaNuovoPacchettoLinea = this.inizializzaNuovoPacchettoLinea.bind(this);
        this.showConfirmPanelLineaModifica = this.showConfirmPanelLineaModifica.bind(this);
        this.salvaPacchettoLineaModifica = this.salvaPacchettoLineaModifica.bind(this);
        this.columnEdit = this.columnEdit.bind(this); 
        this.nomeLinea = this.nomeLinea.bind(this);
        this.inzializzaDoc = this.inzializzaDoc.bind(this);
        this.showConfirmDeletePac = this.showConfirmDeletePac.bind(this);
        this.deletePacchettoDocument = this.deletePacchettoDocument.bind(this);
        this.downloadOnClick = this.downloadOnClick.bind(this);
        this.nomeDocumento = this.nomeDocumento.bind(this);
        this.state = {
            disabilitaSwitch: false,
            validationPacchetoLinea: new Map(),
            showConfirm: false,
            modificaLinea: false,
            showUploadPacchetto: false,
            docDaEliminare: null,
            showConfirmDeletePac:false,
        }
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');
        let accordion = document.getElementsByClassName("prodottoPacchetto" + this.props.index)[0];
        accordion.addEventListener("click", () => setTimeout(() => this.accordionOnClick(), 300));
    }

    accordionOnClick() {
        let columns = [
            { field: 'idLinea', title: 'Id', sortable: 'true' },
            { field: 'linNome', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME_LINEA', 'Nome Linea'), formatter: this.nomeLinea }, 
            { field: 'percentuale', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MIN', 'Percentuale') },
            { field: 'idUserUpd', title: i18n('ARM_CORE_PRODUCT.MANAGE.DESCRIZIONE', 'User Update') },
            { field: 'dateUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_UPDATE', 'Data Update'), formatter: this.dataFormat },
            { field: 'edit', title: 'Modifica', formatter: this.columnEdit, },
            { field: 'docName' , title: 'Nome Documento', formatter: this.nomeDocumento },
            { field: 'elimina', title: 'Elimina', formatter: this.columnDelete, }

        ];


        let tableAcc = document.getElementById("tableAccPacchetto" + this.props.index);

        $(tableAcc).bootstrapTable({
            columns: columns,
            idField: "idLinea",
            sortable: true,
            search: true,
            pageSize: 5,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.editOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        $(tableAcc).bootstrapTable('load', this.props.pacchetto.listProdottoPacchettoLinea);
    }


    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');
        if (nextProps.pacchetto && nextProps.pacchetto.listProdottoPacchettoLinea && nextProps.pacchetto.listProdottoPacchettoLinea) {
            if (nextProps.pacchetto.listProdottoPacchettoLinea !== this.props.pacchetto.listProdottoPacchettoLinea) {

                $(this.refs.pacchettoLineaTable).bootstrapTable('load', nextProps.pacchetto.listProdottoPacchettoLinea);
            }
        }
    }

    columnEdit(value, row, index) {

        let temp = "<button class='btn btn-primary btn-sm'><i class='fas fa-edit fa-fw'></i></button>";
        if (this.props.disabled) {
            temp = "<button disabled class='btn btn-primary btn-sm'><i class='fas fa-edit fa-fw'></i></button>";
        }
        return temp;
    }

    nomeLinea(value, row, index) {
        let LineaTrovata = this.props.fondiList.find(lin => lin.idProdottoLinea == row.idLinea);
        let temp =LineaTrovata ? LineaTrovata.linNome : '-';
        return temp;
    }
    
    nomeDocumento(value,row, index){
        let linea = this.props.fondiList.find(lin => lin.idProdottoLinea == row.idLinea);
        let temp = linea ? linea.docName : '-';
        return temp;
    }


    inizializzaNuovoPacchettoLinea() {
        this.setState({
            validationPacchetoLinea: new Map(),
            modificaLinea: false
        })
        this.props.inizializzaNuovoPacchettoLinea().then(
            resolve => {
                this.showConfirmPanelLinea();
            }
        )

    }

    onClickSalvaLinea(e) {

        this.props.onClickSalvaLinea(e).then(
            resolve => {
                this.accordionOnClick();
                // this.forceUpdate();
            }
        )

    }

    validateFormLinea() {


        let required = ['percentuale', 'idLinea'];
        if (this.state.modificaLinea) {
            required = ['percentuale'];
        }
        let validation = new Map();


        for (let i = 0; i < required.length; i++) {

            if (this.props.linea[required[i]] === null || this.props.linea[required[i]] === undefined || this.props.linea[required[i]] === "") {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }

            if (required[i] === "idLinea") {
                let indexTrovato = this.props.pacchetto.listProdottoPacchettoLinea.findIndex(lin => lin.idLinea == this.props.linea.idLinea);

                if (indexTrovato !== -1) {
                    validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_ESISTENTE_LISTA', 'Linea gia aggiunto sulla lista'));
                }
            }
        }

        let linea = this.props.linea;

        if (linea.percentuale && linea.percentuale !== "") {
            if (linea.percentuale > 100) {
                validation.set("percentuale", i18n('ARM_CORE_PRODUCT.SHARED.VALORE_MAX_ALLOWED', 'valore massima permessa:') + "100");
            }
        }

        this.setState({ validationPacchetoLinea: validation })
        if (validation.size === 0) {
            return true;
        }
        return false;
    }

    validateForm() {
        let listProdottoPacchettoLinea = this.props.pacchetto.listProdottoPacchettoLinea;
        let required = ['percentuale', 'idLinea'];
        let validation = new Map();
        if (listProdottoPacchettoLinea && this.props.sceltaLibera) {

            listProdottoPacchettoLinea.forEach((element, index) => {
                for (let i = 0; i < required.length; i++) {

                    if (element[required[i]] === null || element[required[i]] === undefined || element[required[i]] === "") {
                        validation.set(required[i] + index, i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
                    }
                }
            });

            this.setState({ validationPacchetoLinea: validation })
            if (validation.size === 0) {
                return true;
            }
            return false;
        }
    }


    inputChangeHandler(event, id) {
        console.log(this.componentName + "inputChangeHandler");
        if ((isNullOrUndefined(event) || isNullOrUndefined(event.currentTarget) || isNullOrUndefined(event.currentTarget.id)) && isNullOrUndefined(id)) {
            return
        }
        let parametro;
        let value;
        if (id !== undefined && id !== null) {
            parametro = id;
            value = event
        } else {
            parametro = event.currentTarget.name;
            value = event.target.value;
        }
        let type = event.target.type;
        if (type === "date" && value !== undefined) {
            let data = new Date(value);
            value = data.getTime();
        }

        if (type === "number" && value === "") {
            value = null;
        } else if (type === "number" && value && value !== "") {
            value = Number(value)
        }

        if (parametro === "linDettaglioSottostanti" || type === 'checkbox') {
            if (value === "true") {
                value = true;
            } else if (value === "false") {
                value = false;
            }
        }

        this.props.handleChangeEditPacchetto(this.props.index, parametro, value).then(
            resolve => {

                this.props.validateForm(this.props.index);

            }
        )
    }

    inputChangeHandlerLinea(parametro, value) {

        this.props.inputChangeHandlerLinea(parametro, value).then(
            resolve => {
                if (parametro === "idLinea") {
                    if (this.props.fondiList) {
                        let LineaTrovata = this.props.fondiList.find(lin => lin.idProdottoLinea == this.props.linea.idLinea);

                        if (LineaTrovata) {
                            this.props.inputChangeHandlerLinea("linNome", LineaTrovata.linNome).then(
                                resolve => {
                    
                                }
                            )
                        }
                    }
                }
                this.validateFormLinea();
            }
        )

    }

    editOnClick(row, $element, field) {
        console.log(this.componentName + " deleteOnClick()");

        if (field === "elimina" && !this.props.disabled) {
            this.props.removePacchettoLineaFromList(this.props.index, $element.index())
        } else if (field === "edit" && !this.props.disabled) {
            this.props.inizializzaModificaLinea(row).then(
                resolve => {
                    this.setState({
                        validationPacchetoLinea: new Map(),
                        modificaLinea: true
                    })
                    //this.showConfirmPanelLineaModifica();
                }
            )
        }

    }

    showConfirmPanelLineaModifica() {
        this.setState({ modificaLinea: !this.state.modificaLinea })
    }



    columnDelete(value, row, index) {
        console.log(this.componentName + " columnDelete: " + index);
        let temp;
        if (this.props.disabled) {
            temp = "<button  disabled class='btn btn-danger btn-sm'><i class='fas fa-trash-alt'  data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
            return temp;
        }
        temp = "<button class='btn btn-danger btn-sm'><i class='fas fa-trash-alt' data-toggle='tooltip' data-placement='top' title='Elimina'/></button>";
        return temp;
    }

    salvaPacchettoLinea() {
        if (this.validateFormLinea()) {
            this.showConfirmPanelLinea();
            this.props.salvaPacchettoLinea(this.props.index).then(
                resolve => {
                    this.accordionOnClick();
                }
            )
        }
    }

    salvaPacchettoLineaModifica(e) {
        if (this.validateFormLinea()) {
            this.showConfirmPanelLineaModifica();
            this.props.salvaPacchettoLineaModifica(this.props.index).then(
                resolve => {
                    // this.accordionOnClick();
                }
            )
        }
    }

    dataFormat(value, row, index) {
        if (value === "0") {
            return "-";
        }
        return DateFormatter.dataFormatter(value);
    }

    showConfirmPanel() {
        console.log(" show pop up");
        this.setState({ showConfirm: true })
    }

    showConfirmPanelLinea() {
        console.log(this.componentName + 'showConfirmPanel [showConfirm] ' + this.state.showConfirm);
        this.setState({ showConfirm: !this.state.showConfirm })
    }

    annullaCreazioneLinea() {
        this.showConfirmPanelLinea();
    }

    showUploadPacchetto = () => {
        if (this.props.pacchetto.id) {
            this.setState({ showUploadPacchetto: !this.state.showUploadPacchetto })
        }
    }
   
    downloadOnClick(id) {
        console.log(this.componentName + " showConfirmPanel()");
        let path = "document/download/" + id;
        this.props.downloadDocument(path);
    }

    inzializzaDoc(idDoc) {
        this.setState({ docDaEliminare: idDoc, showConfirmDeletePac: true });
    }

    showConfirmDeletePac(){ 
        this.setState({ showConfirmDeletePac: !this.state.showConfirmDeletePac });
    }

    deletePacchettoDocument() {
        this.showConfirmDeletePac();
        this.props.deleteProdottoPacchettoDocument(this.state.docDaEliminare).then(
            resolve => {
                $('html, body').animate({ scrollTop: 0 }, 1000);
                this.props.getListPacchetti(this.props.pacchetto.idProdotto);
            }
        )
    }

   

    render() {
        console.log(this.componentName + "render [indexLinea] " + this.props.index);
        if (isNullOrUndefined(this.props.pacchetto)) {
            return;
        }
        
        let linea = this.props.pacchetto;
        let disabled = this.props.disabled;
        let isListaToEditButton = this.props.isListaToEditButton;
        let linee = this.props.fondiList;
        
   
        
        let lineaCombo = [];
        if (linee && Array.isArray(linee)) {
            linee.forEach(

                element => {
                    let desc = element.linNome;
                    if (desc) {
                        desc = element.idProdottoLinea + "-" + element.linNome;
                    } else {
                        desc = element.idProdottoLinea
                    }
                    lineaCombo.push({ idProdottoLinea: element.idProdottoLinea, linNome: element.linNome });
                }
            )
        }

        let columns = [
            { field: 'id', title: 'Id', sortable: 'true' }, 
            { field: 'percentuale', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MIN', 'Percentuale') },
            { field: 'linNome', title: i18n('ARM_CORE_PRODUCT.MANAGE.PERC_MIN', 'Descrizione') },
            { field: 'elimina', title: 'Elimina', formatter: this.columnDelete, },


        ];


        return (
            <div className="mt-1 mb-1">

                <agui.Accordion
                    className={"prodottoPacchetto" + this.props.index}
                    disabled={false}
                    loading={false}
                    open={true}
                    marginBottom="12 px"
                >

                    <agui.AccordionHeader
                        className=""
                        open={true}
                        closeIcon="fa fa-chevron-down"
                        openIcon="fa fa-chevron-up"

                    >
                        <div className="mb-3">

                        </div>
                        <div>
                            {this.props.titleCard}
                        </div>
                    </agui.AccordionHeader>

                    <agui.AccordionBody className="mt-2">
                        <div className="row">

                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">

                                <agui.ATextInputV4
                                    id={"nomePacchetto" + this.props.index}
                                    key={"nomePacchetto"}
                                    name={"nomePacchetto"}
                                    className="coolTextInput"
                                    required
                                    label={i18n('ARM_CORE_PRODUCT.LINEA.NOME', 'Nome')}
                                    disabled={this.props.disabled}
                                    validation={this.props.validation}
                                    value={linea ? linea.nomePacchetto : null}
                                    onChange={this.inputChangeHandler}
                                />

                            </div>

                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                                <agui.ATextInputV4
                                    id={"descrizionePacchetto" + this.props.index}
                                    key={"descrizionePacchetto"}
                                    name={"descrizionePacchetto"}
                                    required
                                    validation={this.props.validation}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}
                                    disabled={this.props.disabled}
                                    value={linea ? linea.descrizionePacchetto : null}
                                    onChange={this.inputChangeHandler}
                                />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                                <agui.ATextInputV4 id={"ordine" + this.props.index} type="number"
                                    value={linea.ordine}
                                    validation={this.props.validation}
                                    disabled={this.props.disabled}
                                    name="ordine"
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.POSIZIONE', 'Ordine Visibilità')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                                <agui.ATextInputV4 id={"codBanca" + this.props.index} type="text"
                                    value={linea.codBanca}
                                    validation={this.props.validation}
                                    disabled={this.props.disabled}
                                    name="codBanca"
                                    label={i18n('ARM_CORE_PRODUCT.FONDO.CODICE.BANCA', 'Codice banca')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                                <agui.ATextInputV4 id={"codCompagnia" + this.props.index} type="text"
                                    value={linea.codCompagnia}
                                    validation={this.props.validation}
                                    disabled={this.props.disabled}
                                    name="codCompagnia"
                                    label={i18n('ARM_CORE_PRODUCT.FONDO.CODICE.BANCA', 'Codice compagnia')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            <SwitchButton
                                id="flNonStandard"
                                name="flNonStandard"
                                label={i18n('ARM_CORE_PRODUCT.PRODOTTO.GESTIONE_SEPARARATA', 'Non standard')}
                                value={linea.flNonStandard &&
                                    linea.flNonStandard === true || linea.flNonStandard === "true"}
                                disabled={this.props.disabled}
                                componentClass="col-sm-6 col-md-4 col-lg-2 mb-3"
                                onChange={this.inputChangeHandler}
                            />
                            {linea != null && linea != undefined && linea.docId != null && linea.docId != undefined ?
                                <div >

                                    <agui.aButton id="download" className="float-right btn btn-primary ml-2  mt-2" icon="fas fa-download" onClick={() => this.downloadOnClick(linea.docId)}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'KID')}</agui.aButton>

                                    <agui.aButton id="trash" className="float-right btn btn-danger  mt-2" icon="fas fa-trash-alt" onClick={() => this.inzializzaDoc(linea.id)}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'KID')}</agui.aButton>

                                </div>
                                :
                                <div >
                                    <agui.aButton id="upload" bs="primary" className="float-right mt-2" disabled={linea.id == null || linea.id == undefined} icon="fas fa-upload" onClick={this.showUploadPacchetto}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'KID')}</agui.aButton>
                                </div>
                            }
                            <LineaDocumentUpload show={this.state.showUploadPacchetto} linea={null}  idProdPacchetto={linea.id} idProdottoLineaFondo={""} idProdotto={linea.idProdotto} close={this.showUploadPacchetto} />
                           

                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                            </div>
                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                            </div>
                            { linea && linea.docName ?
                                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                                <agui.ATextInputV4 id={"fileName" + this.props.index} type="text"
                                    value={linea.docName}
                                    validation={this.props.validation}
                                    disabled={this.props.disabled}
                                    name="Nome Documento"
                                    onChange={this.inputChangeHandler} />

                            </div>
                            : null
                            }

                        </div>        

                        <div>
                            {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                                <agui.aButton className="float-left mt-2" bs='primary' disabled={this.props.disabled} onClick={() => this.inizializzaNuovoPacchettoLinea()} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.PACCHETTO.LINEA', 'Linea')}</agui.aButton>
                            }

                        </div>


                        <table id={"tableAccPacchetto" + this.props.index} ref="pacchettoLineaTable" columns={columns} data={this.props.pacchetto.listProdottoPacchettoLinea} className={AppConstants.CLASS_TABLE} />
                    </agui.AccordionBody>

                    {
                        (!isListaToEditButton) ?
                            <div className=" ml-4 mr-4 mb-3">
                                {
                                    (!disabled) ?
                                        <div className='d-flex justify-content-between' >
                                            <agui.aButton bs="secondary" title={i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA_ANULLA', "Annulla modifica")} id={this.props.index} className="float-right" icon="far fa-times-circle" onClick={this.props.onClickAnnullaModifica}></agui.aButton>
                                            <agui.aButton bs="primary" title="Salva Modifiche" id={this.props.index} className="mr-2" icon="fas fa-save" onClick={this.onClickSalvaLinea}></agui.aButton>
                                        </div>
                                        :

                                        linea.inFlcorrisp ?

                                            <div className='d-flex justify-content-between float-right' >

                                                <agui.aButton bs="primary" title={i18n('ARM_CORE_PRODUCT.LINEA.MODIFICA_LINEA', "Modifica linea")} id={this.props.index} className="mr-2" icon="fas fa-edit" onClick={this.props.onClickModificaLinea}></agui.aButton>
                                            </div>
                                            :
                                            <div className='d-flex justify-content-between' >

                                                <agui.aButton id={linea.id} bs="danger" title={i18n('ARM_CORE_PRODUCT.LINEA.ELIMINA_LINEA', "Elimina linea")} className="float-right" icon="fas fa-trash-alt" onClick={this.props.onClickEliminaLinea}></agui.aButton>
                                                <agui.aButton bs="primary" title={i18n('ARM_CORE_PRODUCT.LINEA.MODIFICA_LINEA', "Modifica linea")} id={this.props.index} className="mr-2" icon="fas fa-edit" onClick={this.props.onClickModificaLinea}></agui.aButton>
                                            </div>

                                }
                            </div>
                            :


                            <div className="d-flex flex-row-reverse">
                                <div className="p-2">
                                    {isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                                        <agui.aButton bs="primary" title={i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', "Modifica")} id={"edit"} className="mr-2" icon="fas fa-edit" onClick={this.props.onClickGestioneLinea}>{i18n('ARM_CORE_PRODUCT.SHARED.GESTIONE.Linea', "Gestione")}</agui.aButton>
                                    }
                                </div>
                            </div>
                    }


                </agui.Accordion>
                <agui.ConfirmModalOkCancelV4 show={this.state.showConfirm} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle="Associazione Linea" onClose={this.annullaCreazioneLinea} />
                    <agui.ConfirmModalOkCancelV4.Body testoBody="">

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ASelectV4
                                    id="idLinea"
                                    disabled={false}
                                    onChange={(e) => this.inputChangeHandlerLinea("idLinea", e.target.value)}
                                    value={this.props.linea ? this.props.linea.idLinea : null}
                                    label={i18n('ARM_CORE_PRODUCT.LINEA.LINEA', 'Linea')}
                                    items={lineaCombo}
                                    validation={this.state.validationPacchetoLinea}
                                    valueKey="idProdottoLinea"
                                    labelKey="linNome"
                                />
                            </div>
                        </div>

                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="percentuale" type="number"
                                    value={this.props.linea ? this.props.linea.percentuale : null}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MIN', '% percentuale')}
                                    required={true}
                                    minValueAllowed={0}
                                    validation={this.state.validationPacchetoLinea}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MIN', '% percentuale')}
                                    onChange={(e) => this.inputChangeHandlerLinea("percentuale", e.target.value)} />
                            </div>
                        </div>
                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        confirmOnClick={this.salvaPacchettoLinea} onClose={this.annullaCreazioneLinea}>
                    </agui.ConfirmModalOkCancelV4.Footer>
                </agui.ConfirmModalOkCancelV4>


                <agui.ConfirmModalOkCancelV4 show={this.state.modificaLinea} >
                    <agui.ConfirmModalOkCancelV4.Header testoTitle="Associazione Linea" onClose={this.showConfirmPanelLineaModifica} />
                    <agui.ConfirmModalOkCancelV4.Body testoBody="">
                        <div className="row mt-1">
                            <div className="col col-sm-12 col-md-12 col-lg-12">
                                <agui.ATextInputV4 id="percentuale" type="number"
                                    value={this.props.linea ? this.props.linea.percentuale : null}
                                    placeholder={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MIN', '% percentuale')}
                                    required={true}
                                    minValueAllowed={0}
                                    validation={this.state.validationPacchetoLinea}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.PERC_MIN', '% percentuale')}
                                    onChange={(e) => this.inputChangeHandlerLinea("percentuale", e.target.value)} />
                            </div>
                        </div>
                    </agui.ConfirmModalOkCancelV4.Body >
                    <agui.ConfirmModalOkCancelV4.Footer testoButtonConfirm={i18n('ARM_CORE_PRODUCT.SHARED.SALVA', 'Salva')}
                        confirmOnClick={this.salvaPacchettoLineaModifica} onClose={this.showConfirmPanelLineaModifica}>
                    </agui.ConfirmModalOkCancelV4.Footer>
                </agui.ConfirmModalOkCancelV4>

                <ConfirmModalDeleteV4
                    show={this.state.showConfirmDeletePac}
                    deleteOnClick={this.deletePacchettoDocument}
                    onClose={this.showConfirmDeletePac} />

            </div>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return {

        setPathNameToReturn(path) {
            return dispatch(AppActions.setPathNemeToReturn(path));
        },

        handleChangeLinea(index, parametro, value) {
            return dispatch(ProdottoActions.handleChangeLinea(index, parametro, value));
        },

        handleChangeLineaAnagrafica(index, parametro, value) {
            return dispatch(ProdottoActions.handleChangeLineaAnagrafica(index, parametro, value));
        },

        handleChangeEditPacchetto(index, parametro, value) {
            return dispatch(ProdottoActions.handleChangeEditPacchetto(index, parametro, value));
        },

        removePacchettoLineaFromList(indexLinea, indexFondo) {
            return dispatch(ProdottoActions.removePacchettoLineaFromList(indexLinea, indexFondo))
        },


        inputChangeHandlerLinea(indexLinea, indexFondo, name, value) {
            return dispatch(ProdottoActions.inputChangeHandlerLinea(indexLinea, indexFondo, name, value))
        },

        inputChangeHandlerLinea(name, value) {
            return dispatch(ProdottoActions.inputChangeHandlerLinea(name, value))
        },

        showPopUP(isShow) {
            return dispatch(AppActions.showPopUp(isShow))
        },

        salvaPacchettoLinea(index) {
            return dispatch(ProdottoActions.salvaPacchettoLinea(index))
        },

        inizializzaNuovoPacchettoLinea() {
            return dispatch(ProdottoActions.inizializzaNuovoPacchettoLinea())
        },

        inizializzaModificaLinea(row) {
            return dispatch(ProdottoActions.inizializzaModificaLinea(row))
        },
        salvaPacchettoLineaModifica(row) {
            return dispatch(ProdottoActions.salvaPacchettoLineaModifica(row))
        },
        getListPacchetti(id) {
            return dispatch(ProdottoActions.getListPacchetti(id))
        },
        deleteProdottoPacchettoDocument(id) {
            return dispatch(ProdottoActions.deleteProdottoPacchettoDocument(id))
        },
    
        
    }
};

function mapStateToProps(state) {
    return {
        pathToReturn: state.app.pathNameToReturn,
        showConfirm: state.app.showPopUp,
        linea: state.prodotto.linea,
        prodotto: state.prodotto.detailsProdotto,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(PacchettoCard);
